import { unFormatCurrency, unFormatUnknownUnit } from "@/common/utils/unFormatters";
import { GovernmentAllocationEntryProductValidationSchema } from "@/features/governmentAllocations/schemas/update.schema";

type EntryProductQuantity = {
  id?: string | null;
  product: { id: string };
  total_quantity: string;
};

export const transformNewProduct = (formProduct: GovernmentAllocationEntryProductValidationSchema) => {
  return {
    product_id: formProduct.product.id,
    total_value: formProduct.total_value ? unFormatCurrency(formProduct.total_value) : null,
  };
};

export const transformUpdatedProduct = (formProduct: GovernmentAllocationEntryProductValidationSchema) => {
  const { product_id, ...transformedProduct } = transformNewProduct(formProduct);

  return {
    id: formProduct.id,
    ...transformedProduct,
  };
};

export const transformNewProductQuantity = (formProduct: EntryProductQuantity) => {
  return {
    product_id: formProduct.product.id,
    total_quantity: formProduct.total_quantity ? Number(unFormatUnknownUnit(formProduct.total_quantity)) || 0 : 0,
  };
};

export const transformUpdatedProductQuantity = (formProduct: EntryProductQuantity) => {
  const { product_id, ...transformedProduct } = transformNewProductQuantity(formProduct);

  return {
    id: formProduct.id,
    ...transformedProduct,
  };
};
